import Accordion from '@/common/components/Accordion'
import Spinner from '@/common/components/Spinner'
import { UpdateBillDetailsModal } from '@/features/establishments/components/contract/UpdateBillDetailsModal'
import { EstablishmentContractType } from '@/features/establishments/types/establishmentContract.type'
import { establishmentStrategy as cycleStrategies } from '@/features/privateCompanyLeadsFunnel/constants/cycleOptions.constant'
import { options as weekDaysOptions } from '@/features/privateCompanyLeadsFunnel/constants/weekDaysOptions.constants'
import { useIsFetching, useIsMutating } from '@tanstack/react-query'
import { BinaryIcon, CircleChevronDownIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export const BillDetailsSection = ({ contract }: { contract?: EstablishmentContractType }) => {
  const { id } = useParams()

  const [displayFetching, setDisplayFetching] = useState(false)

  const isMutating = useIsMutating()
  const isFetching = useIsFetching({ queryKey: ['establishmentCompany', id] })

  useEffect(() => {
    isMutating && setDisplayFetching(true)
  }, [isMutating])

  useEffect(() => {
    !isFetching && setDisplayFetching(false)
  }, [isFetching])

  return (
    <Accordion
      defaultOpen
      head={
        <div className="flex items-center gap-x-3 text-white-800">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateBillDetailsModal contract={contract} />
          </div>

          <p>Detalhes da fatura</p>

          {displayFetching && !!isFetching && <Spinner className="fill-white-400 size-4" />}
        </div>
      }
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={
        <div className="flex flex-col gap-y-4 text-white-800">
          <div className="flex items-center gap-x-2">
            <p className="text-[0.6875rem] leading-3">Ciclo de fatura:</p>

            <div className="flex items-center gap-x-1 text-white-400">
              <CircleChevronDownIcon strokeWidth={1} className="size-5 text-white-400" />

              {contract?.cycle ? cycleStrategies[contract.cycle as keyof typeof cycleStrategies] : ''}
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <p className="text-[0.6875rem] leading-3">Dia de abertura:</p>

            <div className="flex items-center gap-x-1">
              <BinaryIcon strokeWidth={1} className="size-5 text-white-400" />

              <p className="text-xs text-white-400">
                {contract?.cycle === 'weekly'
                  ? contract?.cycle_start_day !== null && contract?.cycle_start_day !== undefined
                    ? weekDaysOptions[contract?.cycle_start_day].label
                    : undefined
                  : contract?.cycle_start_day}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-x-2">
            <p className="text-[0.6875rem] leading-3">Vencimento da fatura:</p>

            <div className="flex items-center gap-x-1">
              <BinaryIcon strokeWidth={1} className="size-5 text-white-400" />

              <p className="text-xs text-white-400">
                {contract?.closing_to_due_in_days ? `D+${contract.closing_to_due_in_days}` : '--'}
              </p>
            </div>
          </div>
        </div>
      }
    />
  )
}
